import { getOrElse } from 'fp-ts/lib/Option';
import {
  StyledSubtitleHeader,
  StyledContributionSection,
  StyledUnscoredContributionsCardsWrapper,
  ContributionCardsFlexResponsiveContainer,
} from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/common.styles';
import { CONTRIBUTING_FACTORS } from 'modules/intelligentInsights/brandAffinityInsights/constants';
import {
  useDataManagementContext,
  defaultUnscoredMetrics,
} from 'modules/intelligentInsights/brandAffinityInsights/contexts/dataManagement/DataManagementContext';
import { ContributionsByCampaigns } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/ContributionByCampaigns';
import { ContributionsByChannel } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/ContributionsByChannel';
import { useCoreContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';
import { BrandAffinityLevel } from 'modules/domains';
import { UnscoredMessagingActivity } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/UnscoredMessagingActivity';
import { UnscoredUnsubsubcribeMetrics } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/UnscoredUnsubsubcribeMetrics/UnscoredUnsubsubcribeMetrics';

export const ContributingFactorsCards = () => {
  const { selectedAffinityTab } = useCoreContext();
  const { managedInsightsData } = useDataManagementContext();

  const unscoredMetrics = getOrElse(() => defaultUnscoredMetrics)(
    managedInsightsData.unscoredMetrics,
  );

  return (
    <>
      <StyledSubtitleHeader>{CONTRIBUTING_FACTORS}</StyledSubtitleHeader>
      <StyledContributionSection>
        {selectedAffinityTab === BrandAffinityLevel.UNSCORED ? (
          <StyledUnscoredContributionsCardsWrapper>
            <UnscoredMessagingActivity unscoredMetrics={unscoredMetrics} />
            <UnscoredUnsubsubcribeMetrics unscoredMetrics={unscoredMetrics} />
          </StyledUnscoredContributionsCardsWrapper>
        ) : (
          <ContributionCardsFlexResponsiveContainer>
            <ContributionsByCampaigns />
            <ContributionsByChannel />
          </ContributionCardsFlexResponsiveContainer>
        )}
      </StyledContributionSection>
    </>
  );
};
